import React from "react";
import SimplePopover from "../../components/form/SimplePopover";
import FlatBedImg from "../../images/flatBed.svg";
import { toTitleCase } from "../../utils/textTransform";

export default {
  addressLine1: "Address Line One",
  addressLine2: "Address Line Two",
  city: "City",
  state: "County",
  zip: "Postcode",
  Post_Code: "Post Code",
  vrn: "Vehicle Registration Number",
  confirmation: "Confirmation",
  introText: (vehicleDetails) => {
    return (
      <div>
        We are contacting you on behalf of{" "}
        <strong>{vehicleDetails[0].sellerCompany}</strong> regarding your{" "}
        <strong>
          {vehicleDetails[0].year} {vehicleDetails[0].make}{" "}
          {vehicleDetails[0].model} {vehicleDetails[0].color}
        </strong>
        . If this isn't you, disregard and press the following button.
      </div>
    );
  },

  //`We are contacting you on behalf of ${name}. If this isn't you, disregard and press the following button`,
  notMe: "This is not me",
  insuranceCompany: "Insurance Company",
  adjusterName: "Adjuster",
  ownerName: "Owner",
  lotNumber: "Reference",
  claimNumber: "Claim Number",
  vehicleYear: "Year",
  vehicleMake: "Make",
  vehicleModel: "Model",
  vehicleColor: "Colour",
  vin: "Vehicle Registration Number",
  address: "Address",
  changeAddress: "Change Address",
  next: "Next",
  back: "Back",
  submit: "Submit",
  addressNotMatched:
    "We couldn't match your address with Google Maps, would you like to use their suggested address?",
  useSuggestedAddress: "Use Suggested Address",
  myAddress: "My Address",
  useMyAddress: "Use This Address",
  personal_information: "Personal Information",
  confirm_information: "Please confirm your information",
  address: "Address",
  vehicle_information: "Vehicle Information",
  confirm_vehicle_ready: "Please confirm your vehicle is ready",
  yes: "Yes",
  no: "No",
  need_more_time: "No, I need more time",
  donot_intend_to: "No, I do not intend to",
  do_not_have_keys: "No, I do not have them",
  hours_2: "2 hours",
  hours_4: "4 hours",
  hours_8: "8 hours",
  other: "Other",
  follow_up_in: "Please follow up in",
  vehicle_engine_starts: "Vehicle engine starts",
  vehicle_can_drive_safely: "Vehicle can drive safely under its own power",
  none: "None",
  required_field: "Required Field",
  invalid_input: "Invalid Input",
  ensure_to_sign_your_title:
    "Please ensure to sign your title at the location shown below",
  Otherwise_sign_limited_power_of_attorney:
    "Otherwise please sign this limited power of attorney for us to process the vehicle:",
  get_started: "Get Started",
  network_error: "networkError",
  api_failure: "apiFailure",
  resubmit_form: "Errors in the form. Please resubmit",
  select: "Select",
  close: "close",
  verify: "Verify",
  isReadyForPickup: "Is your vehicle ready for pickup?",
  reason: "Reason",
  needToRemoveItems: "I need to remove items and property",
  insuranceNotSettled: "I have not yet settled with my insurance",
  vehicleNotAccessible: "My vehicle not accessible or no longer",
  vehicleDetailsNotCorrect: "My vehicle details are not correct",
  other: "Other",
  readyAfter: "Ready after",
  doesItDrive: "Does vehicle drive?",
  doesItRoll: "Are your wheels inflated and able to turn freely?",
  tires_inflated: "Tyres are inflated and roll freely",
  pickup_on: "Available for pickup from",
  personalBelongings: "Have you removed personal belongings?",
  pickUpWithBelongings:
    "Are you sure you want Copart to pick your vehicle with your personal belongings in it?",
  isAnythingBlockingComment: "Comment",
  isAnythingBlocking: () => (
    <span>
      Is anything blocking your vehicle from being picked up by large car
      transporter the size of a double-decker bus?{" "}
      <SimplePopover img={FlatBedImg} heading="2 cars carrier" />
    </span>
  ),
  hasKeys: "Are keys with the vehicle?",
  policyHolder: "Policy Holder will be at home?",
  doesWheelsRoll: "Describe the running/rolling condition?",
  vehicleKeysLocation: "Where will the vehicle keys be located?",
  vehicleKeysLocationHelpText:
    "Ideally please leave keys with a neighbor - we cannot take any responsibility if you decide to leave your keys unattended with or near the vehicle.",
  isTowable: "Towable",
  comments: "Comments",
  helpTextKey:
    "Please leave V5C log book and service history inside the vehicle.",
  postCodeHelpText: "(Example: WC2N 5DU)",
  needToBePresent:
    "You do not need to be present for Copart to pickup vehicle, unless there is something preventing the driver from reaching your vehicle. You can leave keys in vehicle, in visor or on floor board.",
  needToBeThereForPickup:
    "Do you need to be there for pickup for driver to access the vehicle?",
  callBefore: "Would you like driver to call 30 minutes before pickup?",
  scheduledAppointment:
    "If you need to be present, do you need to have scheduled appointment?",
  scheduleAppointmentBusinessDays:
    "Please schedule appoinment in the following two business days:",

  vehicleDetails: "Vehicle Details:",
  confirmInfo:
    "Thank you for the information, we will arrange to collect your vehicle as requested. Please ensure your V5C (log book) and any other information such as service records and spare keys are left inside your vehicle.",
  contactUs: (phone) => {
    let ref = `tel:${phone}`;
    return (
      <div>
        If you need to update your response or have additional questions, please
        contact us at <a href={ref}>{phone}</a> during normal business
        hours(Monday through Friday from 8:00 am to 5:00 pm).
      </div>
    );
  },
  inconvenienceMessage:
    "Thank you for responding. We apologize for the inconvenience. Have a great day!",
  vehiclePickedUp:
    "Thank you for your coopertaion, your vehicle has been picked up.",
  callMeMessage: (phone) => {
    let ref = `tel:${phone}`;
    return (
      <div>
        If you have any questions, please contact us at{" "}
        <a href={ref}>{phone}</a> during normal business hours(Monday through
        Friday from 8:00 am to 5:00 pm).
      </div>
    );
  },
  callMe: "Call Me",
  networkFailureSubmit: (phone) => {
    let ref = `tel:${phone}`;
    return (
      <div>
        We couldn't submit your form! We apologize for the inconvenience. We
        will contact you or you can reach us at
        <a href={ref}>{phone}</a>
      </div>
    );
  },
  info: "info",
  networkFailure:
    "Looks like there is problem connecting to the server. We apologize. Please try again later.",
  close: "close",
  noLotIdError: "Bad request UK",
  retry:
    "We are facing network issue. We apologize for the inconvenience. Please try again.",
  callMeSuccess: "Call Me Success",
  failedToFetchLotDetails: "Failed to fetch lot details. Try Reloading",
  failedToValidateAddress: "Failed to validate address. Try Reloading",
  callMeSuccess: "Our CSR will get back to you",
  couldntSubmitForm: (phone) => {
    let ref = `tel:${phone}`;
    return (
      <div>
        We couldn't submit your form! We apologize for the inconvenience. We
        will contact you or you can reach us at
        <a href={ref}>{phone}</a>
      </div>
    );
  },
  landingPageText: (owner) => {
    let ownerName = owner[0];
    return (
      <div>
        Hi <strong>{toTitleCase(ownerName)}</strong>, there are two easy steps
        to have your vehicle picked up!
        <ol className="lp-o-list">
          <li>Confirm your vehicle and personal information</li>
          <li>
            Confirm the vehicle is prepared
            <ul>
              <li>Ensure all keys, including spare keys are available</li>
              <li>Make sure it’s accessible</li>
              <li>Remove your personal items</li>
              <li>
                Clear all personal data from your in-car system where applicable
                e.g: Sat Nav, Bluetooth etc
              </li>
            </ul>
          </li>
        </ol>
      </div>
    );
  },
  partnershipText: () => (
    <div>
      In partnership with <strong>Copart</strong>
    </div>
  ),
};



// WEBPACK FOOTER //
// ./src/locale/sellerLocaleUk/default.js